import React from 'react';

const TrashIcon = (props) => {

  const { size, color, className, onClick } = props;

  return (
        <div className={className} onClick={onClick}>
            <svg xmlns="http://www.w3.org/2000/svg" id="prefix__Grupo_986" width={size} height={size} data-name="Grupo 986" viewBox="0 0 20 20">
                <path id="prefix__Rectángulo_705" fill="none" d="M0 0H20V20H0z" data-name="Rectángulo 705"/>
                <g id="prefix__Group" transform="translate(2.783 2.25)">
                    <path id="prefix__Stroke_141" d="M10.932 13.415H0V0h10.932z" data-name="Stroke 141" transform="translate(1.552 1.862)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" />
                    <path id="prefix__Stroke_143" d="M4.966 1.862H0V0h4.966z" data-name="Stroke 143" transform="translate(4.499)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" />
                    <path id="prefix__Stroke_144" d="M0 0h14.656" data-name="Stroke 144" transform="translate(0 1.862)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" />
                    <path id="prefix__Stroke_145" d="M0 0v7.449" data-name="Stroke 145" transform="translate(4.33 4.626)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" />
                    <path id="prefix__Stroke_146" d="M0 0v7.449" data-name="Stroke 146" transform="translate(6.995 4.626)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" />
                    <path id="prefix__Stroke_147" d="M0 0v7.449" data-name="Stroke 147" transform="translate(9.66 4.626)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" />
                </g>
            </svg>
        </div>
    );
}

export default TrashIcon;